// Sequence tracking persisted in sessionStorage so refreshes mid-sequence
// don't reset progress. Resets after 10s of inactivity between clicks.
const KEY = "dioscuroEasterEgg";
const WINDOW_MS = 10000;

const read = () => {
  if (typeof window === "undefined") return { sequence: [], firstAt: 0 };
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : { sequence: [], firstAt: 0 };
  } catch (_) {
    return { sequence: [], firstAt: 0 };
  }
};

const write = (s) => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(s));
  } catch (_) {}
};

export const recordClick = (cardId) => {
  const now = Date.now();
  const cur = read();

  // Window expired → start fresh. Only "01" can start a new sequence.
  if (cur.firstAt && now - cur.firstAt > WINDOW_MS) {
    const fresh =
      cardId === "01"
        ? { sequence: ["01"], firstAt: now }
        : { sequence: [], firstAt: 0 };
    write(fresh);
    return fresh;
  }

  // Out-of-order → reset (and start fresh if user clicked "01").
  const expected = ["01", "02", "03"][cur.sequence.length];
  if (cardId !== expected) {
    const fresh =
      cardId === "01"
        ? { sequence: ["01"], firstAt: now }
        : { sequence: [], firstAt: 0 };
    write(fresh);
    return fresh;
  }

  const next = {
    sequence: [...cur.sequence, cardId],
    firstAt: cur.firstAt || now,
  };
  write(next);
  return next;
};

export const isUnlocked = (state) =>
  state && Array.isArray(state.sequence) && state.sequence.length === 3;

export const clear = () => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch (_) {}
};
